// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__Btra0","right":"styles_right__1D6-h"};